import { z } from 'zod';

import { IsoDateTime } from '../common/primitives';

export const AdminRoleResponse = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  permissions: z.array(z.string()),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
});
export type AdminRoleResponse = z.infer<typeof AdminRoleResponse>;

export const CreateAdminRoleRequest = z
  .object({
    name: z.string().trim().min(2).max(100),
    description: z.string().trim().max(255).optional(),
    permissions: z.array(z.string()).default([]),
  })
  .strict();
export type CreateAdminRoleRequest = z.infer<typeof CreateAdminRoleRequest>;

export const UpdateAdminRoleRequest = z
  .object({
    name: z.string().trim().min(2).max(100).optional(),
    description: z.string().trim().max(255).nullable().optional(),
    permissions: z.array(z.string()).optional(),
  })
  .strict();
export type UpdateAdminRoleRequest = z.infer<typeof UpdateAdminRoleRequest>;
